import React from "react";

export const ChevronIcon = ({ nameOfClass, handleClick = null, value = null }) => {
    return <svg className={nameOfClass} onClick={(e) => handleClick ? handleClick(value ? value : e) : null} viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 11L11.2265 2.22648C10.8285 1.82847 10.1805 1.83722 9.79342 2.24584L1.5 11" strokeWidth="2" strokeLinecap="round"/>
    </svg>;
};
